if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const modalContent = this.querySelector('.product-media-modal__content');
        //console.log('Opened media id:', mediaId);
        //console.log('Modal: ', modalContent);
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
        ).forEach((element) => {
          element.classList.remove('active');
        });
        /*
        const activeMedia = modalContent.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
        );*/
        const activeMedia = modalContent.querySelector(`:scope > [data-media-id="${mediaId}"]`);
        //console.log('Active media found:', activeMedia);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    },
  );
}
